module.exports = require('./helpers/bundle-url').getBundleURL('9E8ze') + "logo.c51670a8.svg";